<template>
  <s-wrapper>
    <i-bar title="회원검색" class="window-header">
      회원명
      <i-input ref="kword" v-model="search.kword" @keyup.enter="doSearch(1)" class="ml-1"/>
      <!-- <input type="text" ref="kword" v-model="search.kword" @keyup.enter="doSearch(1)" class="ml-1"/> -->
      <i-bar-btn @click="doSearch(2)">검색</i-bar-btn>
      <i-bar-btn @click="doInit">초기화</i-bar-btn>
    </i-bar>

    <s-table3
      ref       = "main"
      :list.sync = "list"
      @loadData  = "getDataList"
    />

  </s-wrapper>
</template>


<script>
let ui
let isDebug = true
export default {
  data () {
    return {
      defaultKword: null,
      search: { // 검색 변수
        kword : '',
      },
      list: {
        headers: T.makeJson(`
          value      | text         | width  | align
          knm        | 회원명       | 220    | center
          membno     | 등록번호     | 70     | center
          hnm        | 한자명       | 80     | center
          birthday   | 생년월일     | 80     | center
          addr       | 동이하 주소  |
        `),
      }
    }
  },
  created() {
    ui = this.$ui
  },
  mounted() {
    this.$refs.main.load()
  },
  methods: {
    doInit ({focusDelay=1}) {
      isDebug && console.log("[c회원선택] doInit()");
      this.search.kword = ''
      this.$refs.main.clear()
    },
    doSearch (no, e) {
      isDebug && console.log("[c회원선택] doSearch : no =", no, ", e =", e)
      this.$refs.main.load()
    },
    getDataList () {
      // if (!this.search.kword) {
      //   ui.alert('검색어를 입력하세요').then(() => { this.doInitFocus() })
      //   this.doInit()
      //   return
      // }
      let list = this.list
      list.loading = true
      const params = {
        iv_pgsize     : list.pageSize,
        iv_page       : list.pageNo,
        iv_membnm     : this.search.kword,  // 회원명
      }
      isDebug && console.log("[c회원선택] getDataList() params = ", params);

      ui.httpGet('/proc/N_MEM_SEL_LIST3_POP'
        , params
        , ret => {
          // console.log("ret.data.rs1[0]", ret.data.rs1[0])
          // console.log("ret.data.rs2", ret.data.rs2)
          // const {tot_rows, tot_pages} = ret.data.rs1[0]

          const {tot_rows} = ret.data.rs1[0]
          list.totalCount  = tot_rows;
          list.items       = ret.data.rs2

          if (tot_rows == 0)
            ui.toast("결과가 없습니다")
          if (tot_rows == 1) { // 결과가 하나인 경우
            this.doClick(list.items[0])
          }
        }
        , null, ()=>list.loading = false)
    },
  },
}
</script>